import { initialState } from '../state/initialState';
import { cookieReducer } from '../reducer/cookieReducer';
import { dialogReducer } from '../reducer/dialogReducer';
const reducer = (state = initialState, action) => {
    return {
        cookieState: cookieReducer(state.cookieState, action),
        dialogState: dialogReducer(state.dialogState, action),
    };
};

export { initialState, reducer };
